var React = require('react');

function IconMinus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.91667 12.5L21.9167 12.5","stroke":"currentColor","strokeWidth":"1.5625","strokeLinecap":"round"}));
}

IconMinus.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconMinus;

IconMinus.default = IconMinus;
